import { render, staticRenderFns } from "./CompanyTimeOffMain.vue?vue&type=template&id=3e67fe72"
import script from "./CompanyTimeOffMain.vue?vue&type=script&lang=js"
export * from "./CompanyTimeOffMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports